import { Location } from 'history';
import { AppName } from 'mk2/containers/Application/Application';
import { makeAbsoluteUrl } from 'mk2/helpers/urls';
import { getLogger } from 'mk2/logger';

const logger = getLogger('TrackReach');

export enum TrackReachProduct {
    DAYS_WITH = 'days_with',
    TESTING = 'testing',
    AMBASSADOR = 'ambassador',
    CONTEST = 'contest',
    NATIVE_ARTICLE = 'native_article',
    IP = 'ip',
}

export function trackReach(location: Location | string, product: string, campaign: number | string, app: AppName | 'blog') {
    // Run on next event loop - so that we are not blocking react
    setTimeout(() => {
        if (document && window && typeof ((window as any).dataLayer) !== 'undefined') {
            let url = '';
            if (typeof location === 'object') {
                url = `${location.pathname}${location.search}${location.hash}`;
            } else if (typeof location === 'string') {
                url = location;
            }

            url = makeAbsoluteUrl(url);

            (window as any).dataLayer.push({
                'event': 'track_reach',
                'product': product,
                'campaign': campaign.toString(),
                'gtm.elementUrl': url,
                'gtm.url': url,
                'pageTitle': document.title,
                'reactApp': app,
            });
        } else {
            logger.error('no GTM datalayer');
        }
    });
}

export function observeBlogPostsForTrackReach(location: Location | string, app: AppName | 'blog') {

    const TIME_TO_READ = 1500;

    const candidatePosts = [];
    const executedPosts = [];

    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
    };

    const remove = (fromArray: any[], item) => {
        const i = fromArray.indexOf(item);
        if (i !== -1) {
            fromArray.splice(i, 1);
        }
    };

    const intersectionCallback = (entries) => {
        entries.forEach((entry) => {
            const postDiv = entry.target;
            const trackReachData = postDiv.getAttribute('data-track-reach');

            if (trackReachData && !executedPosts.includes(postDiv)) {
                const visiblePercentage = Math.floor(entry.intersectionRatio * 100);
                if (visiblePercentage >= 50) {
                    if (!candidatePosts.includes(postDiv)) {
                        candidatePosts.push(postDiv);
                        setTimeout(
                            () => {
                                if (candidatePosts.includes(postDiv)) {
                                    remove(candidatePosts, postDiv);
                                    const trackReachDataJson = JSON.parse(trackReachData);
                                    for (const trackReachProduct in trackReachDataJson) {
                                        if (
                                            trackReachDataJson.hasOwnProperty(trackReachProduct) &&
                                            Array.isArray(trackReachDataJson[trackReachProduct]) &&
                                            trackReachDataJson[trackReachProduct].length > 0
                                        ) {
                                            for (const campaign of trackReachDataJson[trackReachProduct]) {
                                                trackReach(location, trackReachProduct, campaign, app);
                                                executedPosts.push(postDiv);
                                            }
                                        }
                                    }
                                }
                            },
                            TIME_TO_READ,
                        );
                    }
                } else {
                    if (candidatePosts.includes(postDiv)) {
                        remove(candidatePosts, postDiv);
                    }
                }
            }
        });
    };

    const posts = document.querySelectorAll('.photoblog-posts-post.track-reach');
    let observer;
    Array.from(posts).forEach((post) => {
        if ('IntersectionObserver' in window) { // check if browser support for IntersectionObserver
            observer = new IntersectionObserver(intersectionCallback, observerOptions);
            observer.observe(post);
        }
    });
}
